import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListThumbnails = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 4) scale(1.3333)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "combo shape",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.49996 0.375C0.694544 0.375 0.041626 1.02792 0.041626 1.83333V3.5C0.041626 4.30541 0.694544 4.95833 1.49996 4.95833H3.16663C3.97204 4.95833 4.62496 4.30541 4.62496 3.5V1.83333C4.62496 1.02792 3.97204 0.375 3.16663 0.375H1.49996ZM1.49996 7.04167C0.694544 7.04167 0.041626 7.69458 0.041626 8.5V10.1667C0.041626 10.9721 0.694544 11.625 1.49996 11.625H3.16663C3.97204 11.625 4.62496 10.9721 4.62496 10.1667V8.5C4.62496 7.69458 3.97204 7.04167 3.16663 7.04167H1.49996ZM6.70829 1C6.70829 0.654822 6.98811 0.375 7.33329 0.375H12.3333C12.6785 0.375 12.9583 0.654822 12.9583 1C12.9583 1.34518 12.6785 1.625 12.3333 1.625H7.33329C6.98811 1.625 6.70829 1.34518 6.70829 1ZM7.33329 7.04167C6.98811 7.04167 6.70829 7.32149 6.70829 7.66667C6.70829 8.01185 6.98811 8.29167 7.33329 8.29167H12.3333C12.6785 8.29167 12.9583 8.01185 12.9583 7.66667C12.9583 7.32149 12.6785 7.04167 12.3333 7.04167H7.33329ZM6.70829 4.33333C6.70829 3.98816 6.98811 3.70833 7.33329 3.70833H17.3333C17.6785 3.70833 17.9583 3.98816 17.9583 4.33333C17.9583 4.67851 17.6785 4.95833 17.3333 4.95833H7.33329C6.98811 4.95833 6.70829 4.67851 6.70829 4.33333ZM7.33329 10.375C6.98811 10.375 6.70829 10.6548 6.70829 11C6.70829 11.3452 6.98811 11.625 7.33329 11.625H17.3333C17.6785 11.625 17.9583 11.3452 17.9583 11C17.9583 10.6548 17.6785 10.375 17.3333 10.375H7.33329Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgListThumbnails);
export default ForwardRef;
